import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper, Typography } from '@mui/material';
import { fetchWalletBalance } from '../../redux/actions/dashboardActions';
import { ReactComponent as ApiBalanceIcon } from '../Assets/Dashboard/apiBalance.svg';
import { ReactComponent as WalletBalance } from '../Assets/Dashboard/walletBalance.svg';
import { ReactComponent as IWalletBalance } from '../Assets/Dashboard/iWallet.svg';
import { ReactComponent as IAtmBalance } from '../Assets/Dashboard/iAtm.svg';
import { ReactComponent as ChargeBack } from '../Assets/Dashboard/ChargeBack.svg';
import { ReactComponent as LienAmount } from '../Assets/Dashboard/LienAmount.svg';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';

const cardData = [
    {
        title: "API Balance",
        amount: "0.00",
        backgroundColor: "#00178D",
        icon: <ApiBalanceIcon style={{ fontSize: '1rem', color: '#fff' }} />
    },
    {
        title: "CMS Balance",
        amount: "0.00",
        backgroundColor: "#4A148C", // Purple color for distinction
        icon: <AirportShuttleIcon style={{ fontSize: '2rem', color: '#fff' }} /> // You can create a separate icon later
    },
    {
        title: "Wallet Balance",
        amount: "0.00",
        backgroundColor: "#008D39",
        icon: <WalletBalance style={{ fontSize: '3rem', color: '#fff' }} />
    },
    {
        title: "iIT",
        amount: "0.00",
        backgroundColor: "#FF8C00",
        icon: <IWalletBalance style={{ fontSize: '3rem', color: '#fff' }} />
    },
    {
        title: "iATM",
        amount: "0.00",
        backgroundColor: "#4034AB",
        icon: <IAtmBalance style={{ fontSize: '3rem', color: '#fff' }} />
    },
    {
        title: "Charge Back",
        amount: "0.00",
        backgroundColor: "#ff0000",
        icon: <ChargeBack style={{ fontSize: '3rem', color: '#fff' }} />
    },
    {
        title: "Lien Amount",
        amount: "0.00",
        backgroundColor: "#9747FF",
        icon: <LienAmount style={{ fontSize: '3rem', color: '#fff' }} />
    },
];

const Cards = () => {
    const paperStyle = {
        boxShadow: "none",
        padding: "1rem",
        borderRadius: "18px",
        minHeight: "100%", // Ensures all cards have the same height
        width: "100%", // Makes width consistent
        display: "flex",
        flexDirection: "column",
        justifyContent: "Space-between", // Centers items vertically
        flexGrow:1,
      
        
      };
      
    const dispatch = useDispatch();

    // Selectors to get the wallet balance from the Redux store
    const chargeBackBalance = useSelector(state => state.dashboard.chargeBackBalance);
    const walletBalance = useSelector(state => state.dashboard.walletBalance);
    const uType = sessionStorage.getItem("uType"); // Assuming user type is stored in sessionStorage
    const cmsWalletBalance = useSelector(state => state.dashboard.cmsWalletBalance);

    console.log(cmsWalletBalance, "CMS AMount")
    useEffect(() => {
        // Fetch wallet balance when the component mounts
        dispatch(fetchWalletBalance());
    }, [dispatch]);

    // Filter card data based on user type (uType)
    const filteredCardData = () => {
        if (uType === "ADMIN") {
            return cardData.filter(card => (card.title !== "iATM") && (card.title !== "iIT") && (card.title !== "Lien Amount") && (card.title !== "Charge Back") || (card.title === "CMS Balance")); // Show all cards for ADMIN
        } else if (uType === "RETAILER") {
            return cardData.filter(card => card.title !== "API Balance"); // Show all except API Balance for RETAILER
        } else if (uType === "AREADISTRIBUTOR") {
            return cardData.filter(card => (card.title !== "API Balance") && (card.title !== "iIT") && (card.title !== "iATM") && (card.title !== "CMS Balance") ); // Show all except API Balance for RETAILER
        } else if (uType === "CHANNELPARTNER") {
            return cardData.filter(card => (card.title !== "API Balance") && (card.title !== "iIT") && (card.title !== "iATM") && (card.title !== "CMS Balance")); // Show all except API Balance for RETAILER
        } else if (uType === "SUPERDISTRIBUTOR") {
            return cardData.filter(card => (card.title !== "API Balance") && (card.title !== "iIT") && (card.title !== "iATM") && (card.title !== "CMS Balance")); // Show all except API Balance for RETAILER
        } else if (uType === "MASTERDISTRIBUTOR") {
            return cardData.filter(card => (card.title !== "API Balance") && (card.title !== "iIT") && (card.title !== "iATM") && (card.title !== "CMS Balance")); // Show all except API Balance for RETAILER
        } else if (uType === "AREADISTRIBUTOR") {
            return cardData.filter(card => (card.title !== "API Balance") && (card.title !== "iIT") && (card.title !== "iATM") && (card.title !== "CMS Balance")); // Show all except API Balance for RETAILER
        } else {
            return cardData.filter(card => (card.title === "Wallet Balance") && (card.title === "Charge Back") && (card.title !== "Lien Amount") && (card.title !== "CMS Balance") ); // Only show Wallet Balance for other users
        }
    };

    return (
<Paper style={paperStyle}>
<Typography style={{alignSelf: "flex-start", fontWeight: 'bold', fontSize: '16px' }}>Balance</Typography>
            <Grid container spacing={2} style={{ flexGrow:1,marginTop: '1%', display:'flex', justifyContent:'center', alignItems: 'center',}}>
                {filteredCardData().map((card, index) => (
                    <Grid item xs={12} sm={6} md={6} key={index}>
                        <Paper
                            elevation={3}
                            style={{
                                padding: '1.5rem',
                                backgroundColor: card.backgroundColor,
                                color: '#fff',
                                borderRadius: '12px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                boxShadow:'none',
                               
                            }}
                        >
                            {card.icon}
                            <Typography style={{ marginTop: '0.5rem', fontSize: '12px' }}>{card.title}</Typography>
                            <Typography style={{ fontWeight: 'bold' }}>
                                {card.title === "Wallet Balance" 
                                    ? walletBalance.toFixed(2) 
                                    : card.title === "Charge Back" 
                                        ? chargeBackBalance 
                                        : card.title === "CMS Balance" 
                                            ? Number(cmsWalletBalance).toFixed(2)// Display CMS Wallet balance
                                            : card.amount
                                }
                            </Typography>

                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
};

export default Cards;
